import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-process7",
  "use": "icon-process7-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-process7\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 896H256a160 160 0 0 1 0-320h512a160 160 0 0 1 0 320zM256 640a96 96 0 0 0 0 192h512a96 96 0 0 0 0-192z\" fill=\"#C0C5D3\" p-id=\"23168\" /><path d=\"M128 608m128 0l128 0q128 0 128 128l0 0q0 128-128 128l-128 0q-128 0-128-128l0 0q0-128 128-128Z\" fill=\"#C0C5D3\" p-id=\"23169\" /><path d=\"M384 896H256a160 160 0 0 1 0-320h128a160 160 0 0 1 0 320z m-128-256a96 96 0 0 0 0 192h128a96 96 0 0 0 0-192zM384 320a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM640 512a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM320 544a32 32 0 0 1-22.72-9.28 32 32 0 0 1 0-45.44l384-384a32 32 0 1 1 45.44 45.44l-384 384A32 32 0 0 1 320 544z\" fill=\"#C0C5D3\" p-id=\"23170\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/process7.svg
// module id = k3FZ
// module chunks = 197